export const ACCOUNTING_VOUCHER_SLUGS = ['cpv', 'crv', 'fpv', 'frv', 'cheque-pv', 'cheque-rv'];

export const ACCOUNTING_VOUCHERS = [
  {
    slug: 'cpv',
    pageName: 'Cash Payment',
    navKey: 'accounting.cpv',
    title: 'Cash Payment Voucher',
    shortTitle: 'Cash Payment',
    traceNumberName: 'Cash Payment Voucher',
    detailKey: 'CPVDetails',
    masterAccountLabel: 'Paid From (Cash)',
    masterAccountSource: 'cash',
    hasChequeHeader: false,
    hasBankAccount: false,
    detailChequeFields: false,
    defaultProfileKeys: { account: 'DefaultCashAccount', accountId: 'DefaultCashAccountId' },
    apis: {
      list: 'CPVSInView',
      get: 'GetCPV',
      save: 'addCpvMaster',
      delete: 'DeleteCPV',
      nextNo: 'GetNextCPVMasterNo',
    },
    printType: 'CPV',
  },
  {
    slug: 'crv',
    pageName: 'Cash Receipt',
    navKey: 'accounting.crv',
    title: 'Cash Receipt Voucher',
    shortTitle: 'Cash Receipt',
    traceNumberName: 'Cash Receipt Voucher',
    detailKey: 'CRVDetails',
    masterAccountLabel: 'Received In (Cash)',
    masterAccountSource: 'cash',
    hasChequeHeader: false,
    hasBankAccount: false,
    detailChequeFields: false,
    defaultProfileKeys: { account: 'DefaultCashAccount', accountId: 'DefaultCashAccountId' },
    apis: {
      list: 'CRVSInView',
      get: 'GetCRV',
      save: 'addCrvMaster',
      delete: 'DeleteCRV',
      nextNo: 'GetNextCRVMasterNo',
    },
    printType: 'CRV',
  },
  {
    slug: 'fpv',
    pageName: 'Fund Payment',
    navKey: 'accounting.fpv',
    title: 'Fund Payment Voucher',
    shortTitle: 'Fund Payment',
    traceNumberName: 'Fund Payment Voucher',
    detailKey: 'FPVDetails',
    masterAccountLabel: 'Paid From (Bank)',
    masterAccountSource: 'bank',
    hasChequeHeader: false,
    hasBankAccount: false,
    detailChequeFields: false,
    defaultProfileKeys: { account: 'DefaultBankAccount', accountId: 'DefaultBankAccountId' },
    apis: {
      list: 'FPVSInView',
      get: 'GetFPV',
      save: 'addFpvMaster',
      delete: 'DeleteFPV',
      nextNo: 'GetNextFPVMasterNo',
    },
    printType: 'FPV',
  },
  {
    slug: 'frv',
    pageName: 'Fund Receipt',
    navKey: 'accounting.frv',
    title: 'Fund Receipt Voucher',
    shortTitle: 'Fund Receipt',
    traceNumberName: 'Fund Receipt Voucher',
    detailKey: 'FRVDetails',
    masterAccountLabel: 'Received In (Bank)',
    masterAccountSource: 'bank',
    hasChequeHeader: false,
    hasBankAccount: false,
    detailChequeFields: false,
    defaultProfileKeys: { account: 'DefaultBankAccount', accountId: 'DefaultBankAccountId' },
    apis: {
      list: 'FRVSInView',
      get: 'GetFRV',
      save: 'addFrvMaster',
      delete: 'DeleteFRV',
      nextNo: 'GetNextFRVMasterNo',
    },
    printType: 'FRV',
  },
  {
    slug: 'cheque-pv',
    pageName: 'Cheque Payment',
    navKey: 'accounting.chequePv',
    title: 'Cheque Payment Voucher',
    shortTitle: 'Cheque Payment',
    traceNumberName: 'Cheque Payment Voucher',
    detailKey: 'ChequePVDetails',
    masterAccountLabel: 'PDC Payable Account',
    masterAccountSource: 'pdcPay',
    hasChequeHeader: true,
    hasBankAccount: true,
    bankAccountLabel: 'Bank Account',
    detailChequeFields: false,
    defaultProfileKeys: { account: 'DefaultPDCPayAccount', accountId: 'DefaultPDCPayAccountId' },
    bankProfileKeys: { account: 'DefaultBankAccount', accountId: 'DefaultBankAccountId' },
    apis: {
      list: 'ChequePVSInView',
      get: 'GetChequePV',
      save: 'addChequepvMaster',
      delete: 'DeleteChequePV',
      nextNo: 'GetNextChequePVMasterNo',
    },
    printType: 'Cheque PV',
  },
  {
    slug: 'cheque-rv',
    pageName: 'Cheque Receipt',
    navKey: 'accounting.chequeRv',
    title: 'Cheque Receipt Voucher',
    shortTitle: 'Cheque Receipt',
    traceNumberName: 'Cheque Receipt Voucher',
    detailKey: 'ChequeRVDetails',
    masterAccountLabel: 'PDC Receivable Account',
    masterAccountSource: 'pdcRecv',
    hasChequeHeader: true,
    hasBankAccount: true,
    bankAccountLabel: 'Bank Account',
    detailChequeFields: false,
    defaultProfileKeys: { account: 'DefaultPDCRecAccount', accountId: 'DefaultPDCRecAccountId' },
    bankProfileKeys: { account: 'DefaultBankAccount', accountId: 'DefaultBankAccountId' },
    apis: {
      list: 'ChequeRVSInView',
      get: 'GetChequeRV',
      save: 'addChequervMaster',
      delete: 'DeleteChequeRV',
      nextNo: 'GetNextChequeRVMasterNo',
    },
    printType: 'Cheque RV',
  },
];

export function getVoucherConfig(slug) {
  return ACCOUNTING_VOUCHERS.find((v) => v.slug === slug) || null;
}
